program Kundenportal;



{$R *.dres}

uses
  Vcl.Forms,
  WEBLib.Forms,
  WEBLib.WebTools,
  Unit1 in 'Unit1.pas'{*.html},
  Unit2 in 'Unit2.pas',
  unit_Passwortanforderung in 'unit_Passwortanforderung.pas'{*.html},
  unit_Kundendaten in 'unit_Kundendaten.pas'{*.html},
  unit_Rechnungen in 'unit_Rechnungen.pas'{*.html},
  unit_Tickets in 'unit_Tickets.pas'{*.html},
  unit_Support in 'unit_Support.pas'{*.html},
  Unit_EinzelTicket in 'Unit_EinzelTicket.pas'{*.html},
  unit_AenderungKundendaten in 'unit_AenderungKundendaten.pas'{*.html},
  unit_AenderungUSTID in 'unit_AenderungUSTID.pas'{*.html},
  unit_AenderungZugangsdaten in 'unit_AenderungZugangsdaten.pas'{*.html},
  unit_AenderungNewsletter in 'unit_AenderungNewsletter.pas'{*.html},
  unit_Bestellungen in 'unit_Bestellungen.pas'{*.html},
  unit_EinzelBeleg in 'unit_EinzelBeleg.pas'{*.html},
  unit_Provisionsabrechnungen in 'unit_Provisionsabrechnungen.pas'{*.html},
  unit_Nachrichten in 'unit_Nachrichten.pas'{*.html},
  unit_PasswortVergeben in 'unit_PasswortVergeben.pas'{*.html},
  unit_Aktivierung in 'unit_Aktivierung.pas'{*.html},
  unit_AenderungLieferanschrift in 'unit_AenderungLieferanschrift.pas'{*.html},
  unit_AenderungEmailRechnung in 'unit_AenderungEmailRechnung.pas'{*.html},
  unit_SupportKonto in 'unit_SupportKonto.pas'{*.html},
  unit_AbmeldungNewsletter in 'unit_AbmeldungNewsletter.pas'{*.html};

{$R *.res}
  var
    myparam:string;
    code:string;
begin
  Application.Initialize;
  Application.AutoFormRoute := true;
  Application.MainFormOnTaskbar := True;
  Application.CreateForm(TForm1, Form1);
  Application.CreateFormDirect(TDM2, DM2);
  Application.Run;
end.
